import { Camera } from 'three';

export type CameraType = 'perspective' | 'orthographic';

export class SwitchableCamera extends Camera {
  fov = 45;
  aspect = 1;
  offsetX = 0;
  offsetY = 0;
  near = 0.1;
  far = 10000;
  zoom = 1;
  targetDistance = 1;
  cameraType: CameraType = 'perspective';

  constructor() {
    super();
    this.userData = { meshType: 'SwitchableCamera' };
  }

  // Required by Raycaster, even though it's not defined in Three.js typing
  get isOrthographicCamera() {
    return this.cameraType === 'orthographic';
  }

  // Required by Raycaster, even though it's not defined in Three.js typing
  get isPerspectiveCamera() {
    return this.cameraType === 'perspective';
  }

  updateProjectionMatrix() {
    if (this.isOrthographicCamera) {
      this.projectionMatrix.makeOrthographic(
        ...this.calcViewBoundsAtDistance(this.targetDistance),
      );
    } else {
      this.projectionMatrix.makePerspective(
        ...this.calcViewBoundsAtDistance(this.near),
      );
    }
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }

  calcViewBoundsAtDistance(distance: number) {
    const verticalAngularExtent = (this.fov / 2 / 180) * Math.PI;
    let top = (distance * Math.tan(verticalAngularExtent)) / this.zoom;
    const height = 2 * top;
    const width = this.aspect * height;

    top += this.offsetY * height;
    const left = -width / 2 + this.offsetX * width;

    return [
      left,
      left + width,
      top,
      top - height,
      this.near,
      this.far,
    ] as const;
  }
}
